module.exports = __webpack_public_path__ + "img/jhcode.98d3a18d.jpg";